import { clsx } from '../../../../ds/clsx';
import styles from './billing-ui.module.css';

interface ActionLike {
  allowed: boolean;
  reason: string | null;
}

/**
 * The server's reason for refused actions (D-07 „Zahlungen sind in dieser Umgebung noch nicht aktiviert."),
 * shown once below a group of disabled buttons; nothing when every action is allowed.
 */
export function ActionReason({
  actions,
  id,
  className,
}: {
  actions: readonly ActionLike[];
  id?: string | undefined;
  className?: string | undefined;
}) {
  const reasons = [
    ...new Set(actions.filter((action) => !action.allowed && action.reason).map((action) => action.reason)),
  ];
  if (reasons.length === 0) return null;
  return (
    <p id={id} className={clsx(styles.reason, className)}>
      {reasons.join(' ')}
    </p>
  );
}
